import ServiceDurationV1 from './ServiceDurationV1'
import APIService from '@/api/services/APIService/APIServiceImpl'
import { ServiceDurationResponseDTO } from '../../../../../requests-module'

import axios from 'axios'

export default class ServiceDurationV1Impl
    extends APIService
    implements ServiceDurationV1
{
    constructor() {
        const serviceUrl = `https://api-migdal.travelfactory.fr/cms`
        super(serviceUrl)
    }

    public async getServiceDuration(
        startDate: string,
        endDate: string,
        prestIds: number[]
    ): Promise<ServiceDurationResponseDTO> {
        try {
            if (!startDate)
                throw new Error('startDate is mandatory in getServiceDuration')
            if (!endDate)
                throw new Error('endDate is mandatory in getServiceDuration')
            if (!Array.isArray(prestIds))
                throw new Error(
                    'prestIds must be an array in getServiceDuration'
                )
            if (!prestIds)
                throw new Error(
                    'prestIds must have a length in getServiceDuration'
                )
            const { data } = await axios.post(
                `${this.getServiceUrl()}/service-offset`,
                {
                    startDate,
                    endDate,
                    prestIds,
                }
            )
            return data
        } catch (error) {
            console.error(error)
            throw new Error('Error getting service duration')
        }
    }
}
